export const OTHER_THUMB_SIZE_MAPPER = {
	'explore-live-channel-size': 'Explore Live Channel Size',
	'list-for-you-size': 'List For You Size',
	'people-you-might-know-size': 'People You Might Know Size',
	'profile-spotlight-size': 'profile Spotlight Size',
	'qewd-best-of-size': 'Qewd Best Of Size',
};
